import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../App';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

export default function SupportPage() {
  const [loading, setLoading] = useState(false);

  const handleSupport = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${API}/paypal/create-order`, {
        amount: '5.00',
        currency: 'USD',
      });

      const approveUrl = response?.data?.approveUrl || response?.data?.approvalUrl || response?.data?.url;
      if (!approveUrl) {
        toast.error('Could not start PayPal checkout. Please try again.');
        setLoading(false);
        return;
      }

      window.location.href = approveUrl;
    } catch (error) {
      toast.error(error?.response?.data?.detail || 'Failed to create PayPal order. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#F9F9F7] p-6">
      <div className="noise-overlay" />
      <Card className="w-full max-w-lg border-gray-100 shadow-lg">
        <CardHeader className="space-y-2">
          <CardTitle className="text-2xl font-bold tracking-tight text-gray-900">Support Don’t Forget ❤️</CardTitle>
          <CardDescription className="text-base">
            This CRM is being built with zero budget. If it helps you, supporting it keeps the servers alive and lets me add premium features.
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="rounded-xl border bg-white p-4">
            <p className="text-sm text-gray-700">✅ What you get for supporting:</p>
            <ul className="list-disc pl-5 mt-2 text-sm text-gray-600 space-y-1">
              <li>Priority feature requests</li>
              <li>Early access to premium features</li>
              <li>Your name added to supporters list</li>
            </ul>
          </div>

          <Button
            onClick={handleSupport}
            disabled={loading}
            className="w-full h-11 rounded-full bg-[#1A4D2E] hover:bg-[#14532D] text-white"
          >
            {loading ? 'Redirecting to PayPal…' : 'Support via PayPal'}
          </Button>

          <Link to="/crm" className="block">
            <Button variant="outline" className="w-full rounded-full">Back to Dashboard</Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
